import { defineComponent as _defineComponent } from 'vue'
import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { IPortfolioAbout } from '@/modules/wealth/services/portfolio';
import {
  Heading,
  Row,
  InitialAvatarIcon,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { Ref, computed, inject, ref } from 'vue';

import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutLinks',
  props: {
    portfolioId: null
  },
  emits: ['openDelete', 'openRename', 'openChangeBackground'],
  setup(__props: any, { emit }) {

const props = __props as {
  portfolioId: string;
};

const router = useRouter();



const isPortfolioDistributionLoading = inject(
  'isPortfolioDistributionLoading'
) as Ref<boolean>;

const isEnabledBffPortfolioMigration = inject(
  'isEnabledBffPortfolioMigration'
) as Ref<boolean>;

const isPortfolioAboutLoading = inject(
  'isPortfolioAboutLoading'
) as Ref<boolean>;

const reloadCause = inject('reloadCause') as Ref<string>;
const portfolioDistribution = ref<IPortfolioDistributionResponse | undefined>(
  inject<IPortfolioDistributionResponse>('portfolioDistribution')
);
const portfolioAbout = ref<IPortfolioAbout | undefined>(
  inject<IPortfolioAbout>('portfolioAbout')
);
function routeToWalletBuilderEdit() {
  router.push({
    name: 'catalogBuilder',
    params: {
      portfolioId: props.portfolioId,
      type: 'funds'
    }
  });
}

const portfolioName = computed(() => {
  if (isEnabledBffPortfolioMigration.value) {
    if (
      isPortfolioAboutLoading.value === true &&
      reloadCause.value === 'renamePortfolio'
    ) {
      return 'Carregando...';
    }

    return portfolioAbout.value?.name ?? '';
  }

  if (
    isPortfolioDistributionLoading.value === true &&
    reloadCause.value === 'renamePortfolio'
  )
    return 'Carregando...';

  return portfolioDistribution.value?.portfolio?.name ?? '';
});

const isAllowedToDeletePortfolio = computed(() => {
  if (isEnabledBffPortfolioMigration.value) {
    return !portfolioAbout.value?.shouldShowFeesMessage;
  }

  return !portfolioDistribution.value?.portfolio?.shouldShowFeesMessage;
});

const showEditProducts = computed(() => {
  if (isEnabledBffPortfolioMigration.value) {
    return (
      portfolioAbout.value?.isCustom && portfolioAbout.value?.canEditPortfolio
    );
  }

  return (
    portfolioDistribution?.value?.portfolio?.isCustom &&
    portfolioDistribution.value.portfolio.canEditPortfolio
  );
});

const isAllowedToEditPortfolio = computed(() => {
  if (isEnabledBffPortfolioMigration.value) {
    return portfolioAbout.value?.canEditPortfolio;
  }

  return portfolioDistribution.value?.portfolio?.canEditPortfolio;
});

return { __sfc: true,router, emit, props, isPortfolioDistributionLoading, isEnabledBffPortfolioMigration, isPortfolioAboutLoading, reloadCause, portfolioDistribution, portfolioAbout, routeToWalletBuilderEdit, portfolioName, isAllowedToDeletePortfolio, showEditProducts, isAllowedToEditPortfolio, Heading, Row, InitialAvatarIcon, SkeletonLoader }
}

})